webpackJsonp([151],{

/***/ 1163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TargetSettingTable_vue__ = __webpack_require__(2805);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6029a174_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TargetSettingTable_vue__ = __webpack_require__(4671);
function injectStyle (ssrContext) {
  __webpack_require__(4661)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6029a174"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TargetSettingTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6029a174_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TargetSettingTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1441:
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(40);
var getKeys = __webpack_require__(101);
var toIObject = __webpack_require__(100);
var isEnum = __webpack_require__(235).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ 1445:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1446), __esModule: true };

/***/ }),

/***/ 1446:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1447);
module.exports = __webpack_require__(12).Object.values;


/***/ }),

/***/ 1447:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(28);
var $values = __webpack_require__(1441)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ 1513:
/***/ (function(module, exports, __webpack_require__) {

module.exports = function () {
  return new Worker(__webpack_require__.p + "2f6ec96fc704f66aecaa.worker.js");
};

/***/ }),

/***/ 2805:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TargetValueFormDialog_vue__ = __webpack_require__(4663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BatchTargetDialog_vue__ = __webpack_require__(4667);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__core_mixins_table__["b" /* default */]],
  components: {
    TargetValueFormDialog: __WEBPACK_IMPORTED_MODULE_2__components_TargetValueFormDialog_vue__["a" /* default */],
    BatchTargetDialog: __WEBPACK_IMPORTED_MODULE_3__components_BatchTargetDialog_vue__["a" /* default */]
  },
  data: function data() {
    return {
      projectId: null,
      auditProjectRangeId: null,
      targetSettingId: null,
      search: {
        plan_date: null,
        intern_user_id: null,
        audit_project_range_id: null
      },
      searchFieldType: {
        intern_user_id: Number,
        audit_project_range_id: Number
      },
      table: [],
      projectInfo: {},
      editDialogVisible: false,
      editSubmitting: false,
      editForm: {
        id: null,
        intern_name: '',
        plan_date: '',
        plan_order_count: 0
      },
      exportHeader: [{
        key: 'id',
        text: 'ID'
      }, {
        key: 'intern_name',
        text: '实习生'
      }, {
        key: 'plan_date',
        text: '日期'
      }, {
        key: 'plan_order_count',
        text: '目标值单量'
      }, {
        key: 'first_audit_count',
        text: '初审次数'
      }, {
        key: 'multi_audit_count',
        text: '复审次数'
      }, {
        key: 'audit_times_count',
        text: '审核总次数'
      }, {
        key: 'is_target_met',
        text: '是否达标'
      }, {
        key: 'target_rate',
        text: '目标达成率'
      }, {
        key: 'updated_at',
        text: '修改时间'
      }]
    };
  },
  created: function created() {
    // 从路由参数获取项目ID
    this.projectId = this.$route.params.projectId || this.$route.query.projectId;
    this.auditProjectRangeId = this.$route.params.audit_project_range_id || this.$route.query.audit_project_range_id;
    this.syncAuditRangeToSearch();
    if (!this.projectId) {
      this.$message.error('缺少项目ID参数');
      this.$router.back();
      return;
    }
    // 从路由参数获取目标设置ID
    this.targetSettingId = this.$route.query.targetSettingId;
    // 获取项目详情
    this.getProjectInfo();
  },

  methods: {
    /**
     * 将路由上的 audit_project_range_id 同步到 search，保证搜索/分页请求始终携带
     */
    syncAuditRangeToSearch: function syncAuditRangeToSearch() {
      var v = this.auditProjectRangeId;
      this.search.audit_project_range_id = v != null && v !== '' ? Number(v) : null;
    },

    /**
     * 获取实习生列表
     */
    getInternUserTable: function getInternUserTable(params) {
      return request('queryInternTableApi', params);
    },

    /**
     * 获取实习生详情
     */
    getTargetInternUserDetail: function getTargetInternUserDetail(params) {
      return request('getTargetInternUserDetail', params);
    },

    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      return request.page('getTargetValueTable', params);
    },

    /**
     * 获取项目信息
     */
    getProjectInfo: function getProjectInfo() {
      var _this = this;

      if (!this.projectId) {
        return;
      }
      request.common('getProjectDetail', { id: this.projectId }).then(function (_ref) {
        var data = _ref.data;

        _this.projectInfo = {
          status: data.status,
          project_number: data.number,
          project_name: data.name
        };
      }).catch(function () {
        _this.$message.error('获取项目详情失败');
      });
    },

    /**
     * 格式化项目状态
     */
    formatProjectStatus: function formatProjectStatus(status) {
      if (!status && status !== 0) {
        return '-';
      }
      var projectStatusMap = this.projectStatusMap;
      if (!projectStatusMap || !Array.isArray(projectStatusMap)) {
        return status;
      }
      var statusItem = projectStatusMap.find(function (item) {
        return item.value === status * 1;
      });
      return statusItem ? statusItem.label : status;
    },

    /**
     * 导出搜索
     */
    onExportSearch: function onExportSearch() {
      var _this2 = this;

      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
        getResponseData: function getResponseData(data) {
          if (data && data.data) {
            data.data = _this2.handleExportData(data.data);
          }
          return data;
        }
      });
    },

    /**
     * 处理导出数据
     */
    handleExportData: function handleExportData(data) {
      var _this3 = this;

      if (!data || !Array.isArray(data)) {
        return [];
      }
      return data.map(function (row) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, row, {
          plan_date: _this3.formatDate(row.plan_date),
          is_target_met: row.audit_times_count >= row.plan_order_count ? '是' : '否',
          target_rate: (row.plan_order_count > 0 ? Math.min(row.audit_times_count / row.plan_order_count * 100, 100) : 0).toFixed(2) + '%'
        });
      });
    },

    /**
     * 重置表单
     */
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.syncAuditRangeToSearch();
      this.onSearch();
    },

    /**
     * 格式化日期
     */
    formatDate: function formatDate(date) {
      if (!date) return '-';
      var d = new Date(date);
      if (isNaN(d.getTime())) {
        return date;
      }
      return d.getFullYear() + '/' + String(d.getMonth() + 1).padStart(2, '0') + '/' + String(d.getDate()).padStart(2, '0');
    },

    /**
     * 格式化日期时间
     */
    formatDateTime: function formatDateTime(datetime) {
      if (!datetime) return '-';
      var d = new Date(datetime);
      if (isNaN(d.getTime())) {
        return datetime;
      }
      return d.getFullYear() + '/' + String(d.getMonth() + 1).padStart(2, '0') + '/' + String(d.getDate()).padStart(2, '0') + ' ' + String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
    },

    /**
     * 添加目标值
     */
    handleAdd: function handleAdd() {
      this.$refs.formDialog.show();
    },

    /**
     * 批量设置目标值
     */
    handleBatchSet: function handleBatchSet() {
      this.$refs.batchDialog.show();
    },

    /**
     * 打开修改审单目标次数弹窗
     */
    handleEdit: function handleEdit(row) {
      this.editForm = {
        id: row.id,
        intern_name: row.intern_name,
        plan_date: row.plan_date,
        plan_order_count: row.plan_order_count != null ? Number(row.plan_order_count) : 0
      };
      this.editDialogVisible = true;
    },

    /**
     * 弹窗内确认修改
     */
    handleEditConfirm: function handleEditConfirm() {
      var _this4 = this;

      this.editSubmitting = true;
      var submitData = {
        id: this.editForm.id,
        plan_order_count: this.editForm.plan_order_count,
        updater: this.user.name || this.user.username || ''
      };
      request.common('updateTargetValue', submitData).then(function () {
        _this4.$message.success('修改成功');
        _this4.editDialogVisible = false;
        _this4.onRefresh();
      }).finally(function () {
        _this4.editSubmitting = false;
      });
    },

    /**
     * 修改弹窗关闭后重置表单
     */
    onEditDialogClosed: function onEditDialogClosed() {
      this.editForm = {
        id: null,
        intern_name: '',
        plan_date: '',
        plan_order_count: 0
      };
    },

    /**
     * 表单提交成功后的回调
     */
    onFormSubmitted: function onFormSubmitted() {
      this.onRefresh();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    user: function user(state) {
      return state.login.user;
    },
    projectStatusMap: function projectStatusMap(state) {
      return state.customerProjectcost.options.status;
    }
  }))
});

/***/ }),

/***/ 2806:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_components_RemoteSelect__ = __webpack_require__(248);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    RemoteSelect: __WEBPACK_IMPORTED_MODULE_2__core_components_RemoteSelect__["a" /* default */]
  },
  props: {
    projectId: {
      type: [String, Number],
      required: true
    },
    auditProjectRangeId: {
      type: [String, Number],
      default: null
    }
  },
  data: function data() {
    return {
      visible: false,
      formRules: {
        intern_user_id: [{ required: true, message: '请选择实习生', trigger: 'change' }],
        plan_date: [{ required: true, message: '请选择日期', trigger: 'change' }],
        plan_order_count: [{ required: true, message: '请输入目标值单量', trigger: 'blur' }, { type: 'number', min: 1, message: '目标值单量必须大于等于1', trigger: 'blur' }]
      },
      form: {
        intern_user_id: null,
        plan_date: null,
        plan_order_count: 1
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    user: function user(state) {
      return state.login.user;
    }
  }), {
    title: function title() {
      return '添加目标值';
    },
    datePickerOptions: function datePickerOptions() {
      return {
        disabledDate: function disabledDate(time) {
          var today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        }
      };
    }
  }),
  methods: {
    /**
     * 获取实习生列表
     */
    getInternUserTable: function getInternUserTable(params) {
      return request('queryInternTableApi', params);
    },

    /**
     * 获取实习生详情
     */
    getTargetInternUserDetail: function getTargetInternUserDetail(params) {
      return request('getTargetInternUserDetail', params);
    },
    onSubmit: function onSubmit() {
      var _this = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this.create(_this.form);
        } else {
          _this.$message.error('提交内容填写不正确！');
        }
      });
    },
    create: function create(data) {
      var _this2 = this;

      var submitData = {
        audit_project_range_id: this.auditProjectRangeId,
        projectid: this.projectId,
        intern_user_id: data.intern_user_id,
        plan_date: data.plan_date,
        plan_order_count: data.plan_order_count,
        creator: this.user.name || this.user.username || ''
      };

      request.common('createTargetValue', submitData).then(function () {
        _this2.$message.success('创建成功');
        _this2.$emit('submitted');
        _this2.close();
      });
    },
    show: function show() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.visible = true;
      this.$nextTick(function () {
        _this3.$refs.form && _this3.$refs.form.clearValidate();
      });
    },
    close: function close() {
      this.visible = false;
      if (this.$refs['form']) {
        this.$refs['form'].clearValidate && this.$refs['form'].clearValidate();
        this.$refs['form'].resetFields && this.$refs['form'].resetFields();
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
    }
  }
});

/***/ }),

/***/ 2807:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__worker_read_xlsx_worker__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__worker_read_xlsx_worker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__worker_read_xlsx_worker__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var worker = new __WEBPACK_IMPORTED_MODULE_4__worker_read_xlsx_worker___default.a();

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    projectId: {
      type: [String, Number],
      required: true
    },
    auditProjectRangeId: {
      type: [String, Number],
      default: null
    }
  },
  data: function data() {
    return {
      visible: false,
      uploadLoading: false,
      excelData: []
    };
  },

  computed: {},
  methods: {
    /**
     * 下载Excel模板
     */
    downloadTemplate: function downloadTemplate() {
      this.$export('批量设置目标值模板', [{
        '实习生id': 1,
        '目标日期': '2024-01-01',
        '目标值': 10
      }, {
        '实习生id': 2,
        '目标日期': '2024-01-02',
        '目标值': 15
      }], {
        fileHeader: [{ key: '实习生id', text: '实习生id' }, { key: '目标日期', text: '目标日期' }, { key: '目标值', text: '目标值' }]
      });
    },

    /**
     * Excel文件移除
     */
    excelFileRemove: function excelFileRemove() {
      this.excelData = [];
    },

    /**
     * Excel文件变化
     */
    excelFileChange: function excelFileChange(file, fileList) {
      if (file.status === 'ready') {
        if (fileList.length >= 2) {
          fileList.shift();
        }
      }
    },

    /**
     * 上传前验证
     */
    beforeFileUpload: function beforeFileUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('选择文件大小不能超过 2MB!');
      }
      return isLt2M;
    },

    /**
     * 上传请求
     */
    uploadRequest: function uploadRequest(obj) {
      var _this = this;

      this.uploadLoading = true;
      worker.postMessage({ file: obj.file, options: { header: 1 } });
      worker.onmessage = function (event) {
        _this.handleExcelData(event.data);
        _this.uploadLoading = false;
      };
    },

    /**
     * 格式化日期
     * 处理Excel中的各种日期格式：数字序列号、日期对象、字符串
     */
    formatDate: function formatDate(dateValue) {
      if (dateValue === null || dateValue === undefined || dateValue === '') {
        return '';
      }
      // 如果是Date对象
      if (dateValue instanceof Date) {
        if (!isNaN(dateValue.getTime())) {
          var year = dateValue.getFullYear();
          var month = String(dateValue.getMonth() + 1).padStart(2, '0');
          var day = String(dateValue.getDate()).padStart(2, '0');
          return year + '-' + month + '-' + day;
        }
        return '';
      }
      // 如果是字符串
      if (typeof dateValue === 'string') {
        var trimmed = dateValue.trim();
        // 如果已经是 yyyy-MM-dd 格式，直接返回
        if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
          return trimmed;
        }
        // 尝试解析其他格式的日期字符串（如 yyyy/MM/dd, MM/dd/yyyy 等）
        var date = new Date(trimmed);
        if (!isNaN(date.getTime())) {
          var _year = date.getFullYear();
          var _month = String(date.getMonth() + 1).padStart(2, '0');
          var _day = String(date.getDate()).padStart(2, '0');
          return _year + '-' + _month + '-' + _day;
        }
        return trimmed;
      }
      // 如果是数字（可能是Excel日期序列号）
      if (typeof dateValue === 'number') {
        // Excel日期序列号范围：1 到 2958465（对应1900-01-01到9999-12-31）
        // 如果数字在这个范围内，认为是Excel日期序列号
        if (dateValue >= 1 && dateValue <= 2958465) {
          // Excel 1900 日期系统：序列号 1 = 1900-01-01（序列号 n 表示从该日起的第 n 天）
          // 从 1899-12-30 加 n 天会少算一天，应从 1900-01-01 起加 (n - 1) 天
          var excelEpoch = new Date(1900, 0, 1);
          var _date = new Date(excelEpoch.getTime() + (dateValue - 1) * 24 * 60 * 60 * 1000);
          if (!isNaN(_date.getTime())) {
            var _year2 = _date.getFullYear();
            var _month2 = String(_date.getMonth() + 1).padStart(2, '0');
            var _day2 = String(_date.getDate()).padStart(2, '0');
            return _year2 + '-' + _month2 + '-' + _day2;
          }
        }
        // 如果不是Excel日期序列号，可能是时间戳（毫秒）
        if (dateValue > 946684800000) {
          // 2000-01-01的时间戳
          var _date2 = new Date(dateValue);
          if (!isNaN(_date2.getTime())) {
            var _year3 = _date2.getFullYear();
            var _month3 = String(_date2.getMonth() + 1).padStart(2, '0');
            var _day3 = String(_date2.getDate()).padStart(2, '0');
            return _year3 + '-' + _month3 + '-' + _day3;
          }
        }
      }
      return String(dateValue);
    },

    /**
     * 处理Excel数据
     */
    handleExcelData: function handleExcelData(rows) {
      var _this2 = this;

      var items = [];
      var tableHeader = {
        intern_user_id: {
          index: null,
          text: '实习生id'
        },
        plan_date: {
          index: null,
          text: '目标日期'
        },
        plan_order_count: {
          index: null,
          text: '目标值'
        }
      };
      try {
        rows.forEach(function (row, rowIndex) {
          var item = {};
          row.forEach(function (cell, cellIndex) {
            if (rowIndex) {
              // 获得数据行前 检查表头是否存在
              if (rowIndex === 1) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(tableHeader)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var header = _step.value;

                    if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(header.index)) {
                      _this2.uploadLoading = false;
                      _this2.$refs.excelUpload.clearFiles();
                      throw new Error('\u627E\u4E0D\u5230 [' + header.text + '] \u8868\u5934');
                    }
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              }
              // 表格的行数据获取
              for (var field in tableHeader) {
                if (tableHeader.hasOwnProperty(field)) {
                  // 根据字段的 index 获得相应的值
                  if (cellIndex === tableHeader[field].index) {
                    item[field] = cell;
                  }
                }
              }
            } else {
              // 检查表头字段是否存在
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(tableHeader)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _header = _step2.value;

                  if (cell === _header.text) {
                    _header.index = cellIndex;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          });
          if (rowIndex) {
            items.push(item);
          }
        });
        // 转换为后端需要的格式
        this.excelData = items.map(function (item) {
          return {
            audit_project_range_id: _this2.auditProjectRangeId,
            intern_user_id: item.intern_user_id ? Number(item.intern_user_id) : null,
            plan_date: _this2.formatDate(item.plan_date),
            plan_order_count: item.plan_order_count ? Number(item.plan_order_count) : 0
          };
        }).filter(function (item) {
          // 过滤掉无效数据
          return item.intern_user_id && item.plan_date && item.plan_order_count !== null;
        });
        if (this.excelData.length === 0) {
          this.$message.warning('Excel文件中没有有效数据');
        } else {
          this.$message.success('\u6210\u529F\u89E3\u6790 ' + this.excelData.length + ' \u6761\u6570\u636E');
        }
      } catch (e) {
        this.$alert(e.toString(), '提示', { type: 'error' });
        this.excelData = [];
      }
    },

    /**
     * 提交Excel数据
     */
    onSubmitExcel: function onSubmitExcel() {
      var _this3 = this;

      if (!this.excelData || this.excelData.length === 0) {
        this.$message.error('请先上传Excel文件');
        return;
      }
      if (!this.auditProjectRangeId) {
        this.$message.error('缺少audit_project_range_id参数');
        return;
      }
      request.common('batchCreateTargetValue', this.excelData).then(function (response) {
        var data = response.data || {};
        var created = data.created || 0;
        var updated = data.updated || 0;
        var skipped = data.skipped || 0;

        var message = '批量操作完成：';
        var parts = [];
        if (created > 0) {
          parts.push('\u65B0\u589E ' + created + ' \u6761');
        }
        if (updated > 0) {
          parts.push('\u66F4\u65B0 ' + updated + ' \u6761');
        }
        if (skipped > 0) {
          parts.push('\u8DF3\u8FC7 ' + skipped + ' \u6761');
        }
        if (parts.length > 0) {
          message += parts.join('，');
        } else {
          message = '批量操作完成';
        }

        _this3.$message.success(message);
        _this3.$emit('submitted');
        _this3.close();
      }).catch(function () {
        _this3.$message.error('批量创建失败');
      });
    },
    show: function show() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.visible = true;
    },
    close: function close() {
      this.visible = false;
      if (this.$refs.excelUpload) {
        this.$refs.excelUpload.clearFiles();
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
    }
  }
});

/***/ }),

/***/ 4661:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4662);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1ea4a336", content, true, {});

/***/ }),

/***/ 4662:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".pagination[data-v-6029a174]{margin-top:20px;text-align:right}.project-info[data-v-6029a174]{display:inline-block;margin-right:20px}.project-info .info-item[data-v-6029a174]{margin-right:20px;font-size:14px;color:#606266}.action-buttons[data-v-6029a174]{display:inline-block}", "", {"version":3,"sources":["/workspace/src/views/order-review-target-management/pages/TargetSettingTable.vue"],"names":[],"mappings":"AACA,6BAA6B,gBAAgB,gBAAgB,CAC5D,AACD,+BAA+B,qBAAqB,iBAAiB,CACpE,AACD,0CAA0C,kBAAkB,eAAe,aAAa,CACvF,AACD,iCAAiC,oBAAoB,CACpD","file":"TargetSettingTable.vue","sourcesContent":["\n.pagination[data-v-6029a174]{margin-top:20px;text-align:right\n}\n.project-info[data-v-6029a174]{display:inline-block;margin-right:20px\n}\n.project-info .info-item[data-v-6029a174]{margin-right:20px;font-size:14px;color:#606266\n}\n.action-buttons[data-v-6029a174]{display:inline-block\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4663:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TargetValueFormDialog_vue__ = __webpack_require__(2806);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6359eead_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TargetValueFormDialog_vue__ = __webpack_require__(4666);
function injectStyle (ssrContext) {
  __webpack_require__(4664)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6359eead"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TargetValueFormDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6359eead_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TargetValueFormDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 4664:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4665);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("5d2e954c", content, true, {});

/***/ }),

/***/ 4665:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TargetValueFormDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4666:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.title,"close-on-click-modal":false,"width":"500px","visible":_vm.visible},on:{"closed":_vm.close,"update:visible":function($event){_vm.visible=$event}}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"100px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('el-form-item',{attrs:{"label":"实习生","prop":"intern_user_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"placeholder":"请输入实习生姓名搜索","clearable":"","id-key":"id","label-key":"name","value-key":"id","keyword-key":"name","query-request":_vm.getInternUserTable,"find-request":_vm.getTargetInternUserDetail},model:{value:(_vm.form.intern_user_id),callback:function ($$v) {_vm.$set(_vm.form, "intern_user_id", $$v)},expression:"form.intern_user_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"日期","prop":"plan_date"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"type":"date","placeholder":"请选择日期","value-format":"yyyy-MM-dd","picker-options":_vm.datePickerOptions,"clearable":""},model:{value:(_vm.form.plan_date),callback:function ($$v) {_vm.$set(_vm.form, "plan_date", $$v)},expression:"form.plan_date"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"目标值单量","prop":"plan_order_count"}},[_c('el-input-number',{staticClass:"width-max",attrs:{"min":1,"precision":0},model:{value:(_vm.form.plan_order_count),callback:function ($$v) {_vm.$set(_vm.form, "plan_order_count", $$v)},expression:"form.plan_order_count"}})],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){return _vm.close()}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v("提交\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 4667:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BatchTargetDialog_vue__ = __webpack_require__(2807);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ef3dd26_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BatchTargetDialog_vue__ = __webpack_require__(4670);
function injectStyle (ssrContext) {
  __webpack_require__(4668)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8ef3dd26"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BatchTargetDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ef3dd26_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BatchTargetDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 4668:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4669);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("b8348b00", content, true, {});

/***/ }),

/***/ 4669:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".upload-container[data-v-8ef3dd26]{padding:8px 0}.template-section[data-v-8ef3dd26]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:20px;padding-bottom:16px;border-bottom:1px solid #f0f0f0}.template-section .download-btn[data-v-8ef3dd26]{padding:0;color:#409eff;font-size:14px}.template-section .download-btn[data-v-8ef3dd26]:hover{color:#66b1ff}.template-section .download-btn i[data-v-8ef3dd26]{margin-right:4px}.template-section .template-tip[data-v-8ef3dd26]{font-size:12px;color:#909399}.upload-area[data-v-8ef3dd26]{margin-bottom:20px}.upload-area .excel-upload[data-v-8ef3dd26]{width:100%}.upload-area .excel-upload ::v-deep .el-upload-dragger[data-v-8ef3dd26]{width:100%;height:180px;border:1.5px dashed #dcdfe6;border-radius:6px;background:#fafbfc;-webkit-transition:all .2s ease;transition:all .2s ease}.upload-area .excel-upload ::v-deep .el-upload-dragger[data-v-8ef3dd26]:hover{border-color:#409eff;background:#f5f9ff}.upload-area .excel-upload ::v-deep .el-upload-dragger .upload-content[data-v-8ef3dd26]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%;padding:20px}.upload-area .excel-upload ::v-deep .el-upload-dragger .upload-content .upload-icon-wrapper[data-v-8ef3dd26]{width:64px;height:64px;border-radius:50%;background:#f0f2f5;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:16px;-webkit-transition:all .2s ease;transition:all .2s ease}.upload-area .excel-upload ::v-deep .el-upload-dragger .upload-content .upload-icon-wrapper i[data-v-8ef3dd26]{font-size:32px;color:#909399;-webkit-transition:all .2s ease;transition:all .2s ease}.upload-area .excel-upload ::v-deep .el-upload-dragger .upload-content .upload-text[data-v-8ef3dd26]{text-align:center}.upload-area .excel-upload ::v-deep .el-upload-dragger .upload-content .upload-text .main-text[data-v-8ef3dd26]{font-size:15px;color:#606266;margin:0 0 6px;font-weight:500}.upload-area .excel-upload ::v-deep .el-upload-dragger .upload-content .upload-text .main-text em[data-v-8ef3dd26]{color:#409eff;font-style:normal;cursor:pointer}.upload-area .excel-upload ::v-deep .el-upload-dragger .upload-content .upload-text .sub-text[data-v-8ef3dd26]{font-size:12px;color:#909399;margin:0}.upload-area .excel-upload ::v-deep .el-upload-dragger:hover .upload-icon-wrapper[data-v-8ef3dd26]{background:#e6f4ff}.upload-area .excel-upload ::v-deep .el-upload-dragger:hover .upload-icon-wrapper i[data-v-8ef3dd26]{color:#409eff;-webkit-transform:translateY(-2px);transform:translateY(-2px)}.preview-section[data-v-8ef3dd26]{margin-top:20px;padding-top:16px;border-top:1px solid #f0f0f0}.preview-section .preview-info[data-v-8ef3dd26]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:12px;font-size:13px;color:#67c23a}.preview-section .preview-info i[data-v-8ef3dd26]{margin-right:6px;font-size:16px}.preview-section .preview-table[data-v-8ef3dd26]{background:#fafbfc;border-radius:4px;padding:12px;overflow:hidden}.preview-section .preview-table ::v-deep .el-table[data-v-8ef3dd26]{background:transparent}.preview-section .preview-table ::v-deep .el-table[data-v-8ef3dd26]:before{display:none}.preview-section .preview-table ::v-deep .el-table th[data-v-8ef3dd26]{background:transparent;border:none;padding:8px 0;font-size:12px;color:#909399;font-weight:500}.preview-section .preview-table ::v-deep .el-table td[data-v-8ef3dd26]{border:none;padding:8px 0;font-size:13px;color:#606266}.preview-section .preview-table ::v-deep .el-table tr[data-v-8ef3dd26],.preview-section .preview-table ::v-deep .el-table tr[data-v-8ef3dd26]:hover{background:transparent}.preview-section .preview-table .preview-more[data-v-8ef3dd26]{text-align:center;padding-top:8px;font-size:12px;color:#909399}.fade-enter-active[data-v-8ef3dd26],.fade-leave-active[data-v-8ef3dd26]{-webkit-transition:opacity .3s ease;transition:opacity .3s ease}.fade-enter[data-v-8ef3dd26],.fade-leave-to[data-v-8ef3dd26]{opacity:0}.dialog-footer .el-button[data-v-8ef3dd26]{min-width:90px}::v-deep .batch-dialog .el-dialog__body[data-v-8ef3dd26]{padding:20px}", "", {"version":3,"sources":["/workspace/src/views/order-review-target-management/components/BatchTargetDialog.vue"],"names":[],"mappings":"AACA,mCAAmC,aAAa,CAC/C,AACD,mCAAmC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,mBAAmB,oBAAoB,+BAA+B,CAC5S,AACD,iDAAiD,UAAU,cAAc,cAAc,CACtF,AACD,uDAAuD,aAAa,CACnE,AACD,mDAAmD,gBAAgB,CAClE,AACD,iDAAiD,eAAe,aAAa,CAC5E,AACD,8BAA8B,kBAAkB,CAC/C,AACD,4CAA4C,UAAU,CACrD,AACD,wEAAwE,WAAW,aAAa,4BAA4B,kBAAkB,mBAAmB,gCAAiC,uBAAwB,CACzN,AACD,8EAA8E,qBAAqB,kBAAkB,CACpH,AACD,wFAAwF,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,YAAY,YAAY,CACnZ,AACD,6GAA6G,WAAW,YAAY,kBAAkB,mBAAmB,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,mBAAmB,gCAAiC,uBAAwB,CAC/a,AACD,+GAA+G,eAAe,cAAc,gCAAiC,uBAAwB,CACpM,AACD,qGAAqG,iBAAiB,CACrH,AACD,gHAAgH,eAAe,cAAc,eAAiB,eAAe,CAC5K,AACD,mHAAmH,cAAc,kBAAkB,cAAc,CAChK,AACD,+GAA+G,eAAe,cAAc,QAAQ,CACnJ,AACD,mGAAmG,kBAAkB,CACpH,AACD,qGAAqG,cAAc,mCAAmC,0BAA0B,CAC/K,AACD,kCAAkC,gBAAgB,iBAAiB,4BAA4B,CAC9F,AACD,gDAAgD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,mBAAmB,eAAe,aAAa,CACrN,AACD,kDAAkD,iBAAiB,cAAc,CAChF,AACD,iDAAiD,mBAAmB,kBAAkB,aAAa,eAAe,CACjH,AACD,oEAAoE,sBAAsB,CACzF,AACD,2EAA4E,YAAY,CACvF,AACD,uEAAuE,uBAAuB,YAAY,cAAc,eAAe,cAAc,eAAe,CACnK,AACD,uEAAuE,YAAY,cAAc,eAAe,aAAa,CAC5H,AAGD,oJAA6E,sBAAsB,CAClG,AACD,+DAA+D,kBAAkB,gBAAgB,eAAe,aAAa,CAC5H,AACD,wEAAwE,oCAAqC,2BAA4B,CACxI,AACD,6DAA6D,SAAS,CACrE,AACD,2CAA2C,cAAc,CACxD,AACD,yDAAyD,YAAY,CACpE","file":"BatchTargetDialog.vue","sourcesContent":["\n.upload-container[data-v-8ef3dd26]{padding:8px 0\n}\n.template-section[data-v-8ef3dd26]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:20px;padding-bottom:16px;border-bottom:1px solid #f0f0f0\n}\n.template-section .download-btn[data-v-8ef3dd26]{padding:0;color:#409eff;font-size:14px\n}\n.template-section .download-btn[data-v-8ef3dd26]:hover{color:#66b1ff\n}\n.template-section .download-btn i[data-v-8ef3dd26]{margin-right:4px\n}\n.template-section .template-tip[data-v-8ef3dd26]{font-size:12px;color:#909399\n}\n.upload-area[data-v-8ef3dd26]{margin-bottom:20px\n}\n.upload-area .excel-upload[data-v-8ef3dd26]{width:100%\n}\n.upload-area .excel-upload ::v-deep .el-upload-dragger[data-v-8ef3dd26]{width:100%;height:180px;border:1.5px dashed #dcdfe6;border-radius:6px;background:#fafbfc;-webkit-transition:all 0.2s ease;transition:all 0.2s ease\n}\n.upload-area .excel-upload ::v-deep .el-upload-dragger[data-v-8ef3dd26]:hover{border-color:#409eff;background:#f5f9ff\n}\n.upload-area .excel-upload ::v-deep .el-upload-dragger .upload-content[data-v-8ef3dd26]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%;padding:20px\n}\n.upload-area .excel-upload ::v-deep .el-upload-dragger .upload-content .upload-icon-wrapper[data-v-8ef3dd26]{width:64px;height:64px;border-radius:50%;background:#f0f2f5;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:16px;-webkit-transition:all 0.2s ease;transition:all 0.2s ease\n}\n.upload-area .excel-upload ::v-deep .el-upload-dragger .upload-content .upload-icon-wrapper i[data-v-8ef3dd26]{font-size:32px;color:#909399;-webkit-transition:all 0.2s ease;transition:all 0.2s ease\n}\n.upload-area .excel-upload ::v-deep .el-upload-dragger .upload-content .upload-text[data-v-8ef3dd26]{text-align:center\n}\n.upload-area .excel-upload ::v-deep .el-upload-dragger .upload-content .upload-text .main-text[data-v-8ef3dd26]{font-size:15px;color:#606266;margin:0 0 6px 0;font-weight:500\n}\n.upload-area .excel-upload ::v-deep .el-upload-dragger .upload-content .upload-text .main-text em[data-v-8ef3dd26]{color:#409eff;font-style:normal;cursor:pointer\n}\n.upload-area .excel-upload ::v-deep .el-upload-dragger .upload-content .upload-text .sub-text[data-v-8ef3dd26]{font-size:12px;color:#909399;margin:0\n}\n.upload-area .excel-upload ::v-deep .el-upload-dragger:hover .upload-icon-wrapper[data-v-8ef3dd26]{background:#e6f4ff\n}\n.upload-area .excel-upload ::v-deep .el-upload-dragger:hover .upload-icon-wrapper i[data-v-8ef3dd26]{color:#409eff;-webkit-transform:translateY(-2px);transform:translateY(-2px)\n}\n.preview-section[data-v-8ef3dd26]{margin-top:20px;padding-top:16px;border-top:1px solid #f0f0f0\n}\n.preview-section .preview-info[data-v-8ef3dd26]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:12px;font-size:13px;color:#67c23a\n}\n.preview-section .preview-info i[data-v-8ef3dd26]{margin-right:6px;font-size:16px\n}\n.preview-section .preview-table[data-v-8ef3dd26]{background:#fafbfc;border-radius:4px;padding:12px;overflow:hidden\n}\n.preview-section .preview-table ::v-deep .el-table[data-v-8ef3dd26]{background:transparent\n}\n.preview-section .preview-table ::v-deep .el-table[data-v-8ef3dd26]::before{display:none\n}\n.preview-section .preview-table ::v-deep .el-table th[data-v-8ef3dd26]{background:transparent;border:none;padding:8px 0;font-size:12px;color:#909399;font-weight:500\n}\n.preview-section .preview-table ::v-deep .el-table td[data-v-8ef3dd26]{border:none;padding:8px 0;font-size:13px;color:#606266\n}\n.preview-section .preview-table ::v-deep .el-table tr[data-v-8ef3dd26]{background:transparent\n}\n.preview-section .preview-table ::v-deep .el-table tr[data-v-8ef3dd26]:hover{background:transparent\n}\n.preview-section .preview-table .preview-more[data-v-8ef3dd26]{text-align:center;padding-top:8px;font-size:12px;color:#909399\n}\n.fade-enter-active[data-v-8ef3dd26],.fade-leave-active[data-v-8ef3dd26]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-8ef3dd26],.fade-leave-to[data-v-8ef3dd26]{opacity:0\n}\n.dialog-footer .el-button[data-v-8ef3dd26]{min-width:90px\n}\n::v-deep .batch-dialog .el-dialog__body[data-v-8ef3dd26]{padding:20px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"batch-dialog",attrs:{"title":"批量设置目标值","close-on-click-modal":false,"width":"600px","visible":_vm.visible},on:{"closed":_vm.close,"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticClass:"upload-container"},[_c('div',{staticClass:"template-section"},[_c('el-button',{staticClass:"download-btn",attrs:{"type":"text","icon":"el-icon-download"},on:{"click":_vm.downloadTemplate}},[_vm._v("\n        下载Excel模板\n      ")]),_vm._v(" "),_c('span',{staticClass:"template-tip"},[_vm._v("表头：实习生id、目标日期、目标值")])],1),_vm._v(" "),_c('div',{staticClass:"upload-area"},[_c('el-upload',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.uploadLoading),expression:"uploadLoading"}],ref:"excelUpload",staticClass:"excel-upload",attrs:{"drag":"","action":"","accept":".xlsx","on-remove":_vm.excelFileRemove,"on-change":_vm.excelFileChange,"before-upload":_vm.beforeFileUpload,"http-request":_vm.uploadRequest}},[_c('div',{staticClass:"upload-content"},[_c('div',{staticClass:"upload-icon-wrapper"},[_c('i',{staticClass:"el-icon-upload2"})]),_vm._v(" "),_c('div',{staticClass:"upload-text"},[_c('p',{staticClass:"main-text"},[_vm._v("拖拽文件到此处或"),_c('em',[_vm._v("点击上传")])]),_vm._v(" "),_c('p',{staticClass:"sub-text"},[_vm._v("仅支持 .xlsx 格式，最大 2MB")])])])])],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.excelData && _vm.excelData.length > 0)?_c('div',{staticClass:"preview-section"},[_c('div',{staticClass:"preview-info"},[_c('i',{staticClass:"el-icon-success"}),_vm._v(" "),_c('span',[_vm._v("已解析 "+_vm._s(_vm.excelData.length)+" 条数据")])]),_vm._v(" "),_c('div',{staticClass:"preview-table"},[_c('el-table',{attrs:{"data":_vm.excelData.slice(0, 3),"size":"small","show-header":true,"border":false}},[_c('el-table-column',{attrs:{"prop":"intern_user_id","label":"实习生ID","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"plan_date","label":"目标日期","width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"plan_order_count","label":"目标值","width":"80"}})],1),_vm._v(" "),(_vm.excelData.length > 3)?_c('div',{staticClass:"preview-more"},[_vm._v("\n            还有 "+_vm._s(_vm.excelData.length - 3)+" 条数据...\n          ")]):_vm._e()],1)]):_vm._e()])],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){return _vm.close()}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":!_vm.excelData || _vm.excelData.length === 0},on:{"click":function($event){return _vm.onSubmitExcel()}}},[_vm._v("\n      提交"+_vm._s(_vm.excelData && _vm.excelData.length > 0 ? (" (" + (_vm.excelData.length) + ")") : '')+"\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 4671:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("审单考核管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ name: '目标项目设定' }}},[_vm._v("目标项目列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":true}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"日期","prop":"plan_date"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"type":"date","placeholder":"请选择日期","value-format":"yyyy-MM-dd","clearable":""},model:{value:(_vm.search.plan_date),callback:function ($$v) {_vm.$set(_vm.search, "plan_date", $$v)},expression:"search.plan_date"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"实习生","prop":"intern_user_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"placeholder":"请输入实习生姓名搜索","clearable":"","id-key":"id","label-key":"name","value-key":"id","keyword-key":"name","query-request":_vm.getInternUserTable,"find-request":_vm.getTargetInternUserDetail},model:{value:(_vm.search.intern_user_id),callback:function ($$v) {_vm.$set(_vm.search, "intern_user_id", $$v)},expression:"search.intern_user_id"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit","size":"mini"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){return _vm.resetForm('searchForm')}}},[_vm._v("重置\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.onExportSearch}},[_vm._v("导出\n        ")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('div',{staticClass:"project-info"},[_c('span',{staticClass:"info-item"},[_vm._v("项目状态: "+_vm._s(_vm.formatProjectStatus(_vm.projectInfo.status)))]),_vm._v(" "),_c('span',{staticClass:"info-item"},[_vm._v("项目编号: "+_vm._s(_vm.projectInfo.project_number || '-'))]),_vm._v(" "),_c('span',{staticClass:"info-item"},[_vm._v("项目名称: "+_vm._s(_vm.projectInfo.project_name || '-'))])]),_vm._v(" "),_c('div',{staticClass:"action-buttons"},[_c('el-button',{attrs:{"type":"primary","size":"mini","icon":"el-icon-plus"},on:{"click":_vm.handleAdd}},[_vm._v("添加目标值\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"warning","size":"mini"},on:{"click":_vm.handleBatchSet}},[_vm._v("批量设置目标值\n        ")])],1)]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"实习生","min-width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.intern_name || '-')+" / "+_vm._s(scope.row.intern_user_id != null && scope.row.intern_user_id !== '' ? scope.row.intern_user_id : '-')+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"plan_date","label":"日期","width":"120","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm.formatDate(scope.row.plan_date))+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"plan_order_count","label":"审单目标次数","width":"150","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.plan_order_count || 0)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"first_audit_count","label":"初审次数","width":"120","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.first_audit_count != null ? scope.row.first_audit_count : '-')+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"multi_audit_count","label":"复审次数","width":"120","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.multi_audit_count != null ? scope.row.multi_audit_count : '-')+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"是否达标","width":"100","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.audit_times_count >= scope.row.plan_order_count ? '是' : '否')+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"目标达成率","width":"100","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.plan_order_count > 0 ? Math.min(scope.row.audit_times_count / scope.row.plan_order_count * 100, 100).toFixed(2) + '%' : '0.00%')+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updated_at","label":"修改时间","width":"180","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","width":"120","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.handleEdit(scope.row)}}},[_vm._v("修改\n          ")])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2),_vm._v(" "),_c('target-value-form-dialog',{ref:"formDialog",attrs:{"project-id":_vm.projectId,"audit-project-range-id":_vm.auditProjectRangeId},on:{"submitted":_vm.onFormSubmitted}}),_vm._v(" "),_c('batch-target-dialog',{ref:"batchDialog",attrs:{"project-id":_vm.projectId,"audit-project-range-id":_vm.auditProjectRangeId},on:{"submitted":_vm.onFormSubmitted}}),_vm._v(" "),_c('el-dialog',{attrs:{"title":"修改审单目标次数","visible":_vm.editDialogVisible,"close-on-click-modal":false,"width":"440px"},on:{"update:visible":function($event){_vm.editDialogVisible=$event},"closed":_vm.onEditDialogClosed}},[_c('el-form',{ref:"editFormRef",attrs:{"model":_vm.editForm,"label-width":"100px","size":"medium"}},[_c('el-form-item',{attrs:{"label":"实习生"}},[_c('span',[_vm._v(_vm._s(_vm.editForm.intern_name || '-'))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"日期"}},[_c('span',[_vm._v(_vm._s(_vm.formatDate(_vm.editForm.plan_date)))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"审单目标次数","prop":"plan_order_count"}},[_c('el-input-number',{staticClass:"width-max",attrs:{"min":0,"precision":0,"controls-position":"right"},model:{value:(_vm.editForm.plan_order_count),callback:function ($$v) {_vm.$set(_vm.editForm, "plan_order_count", $$v)},expression:"editForm.plan_order_count"}})],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.editDialogVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.editSubmitting},on:{"click":_vm.handleEditConfirm}},[_vm._v("确认\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/order-review-assessment-target-setting-detail.17a27c017213654a23d9.js